<template>
  <div>
    <el-drawer
      v-if="visible"
      :visible="visible"
      :title="title"
      direction="rtl"
      :size="1000"
      :close-on-press-escape="false"
      @close="$refs.editForm.cancel()"
    >
      <EditForm
        ref="editForm"
        :disabled="disabled"
        :imageDisabled="imageDisabled"
        :greyFabricCode="greyFabricCode"
        @close="close"
      />
    </el-drawer>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'personal-myLoanRequest-detail',
  components: { EditForm },
  props: {
    visible: { type: Boolean, default: false },
    greyFabricCode: { type: String, default: '' },
    pageType: { type: String, default: '' },
    title: { type: String, default: '' },
  },
  computed: {
    disabled() {
      return this.pageType === 'detail'
    },
    //图片维护按钮控制
    imageDisabled() {
      return this.pageType === 'detail' || this.pageType === 'add'
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
      if (!this.disabled) this.$emit('reload')
    },
  },
}
</script>
